const marketingAutomationReducer = (
    state = {
        isSystemMessagesActivated: false
    },
    action: {
        type:
        | "SET_SYSTEM_MESSAGES_ACTIVATED"
        payload: any;
    }
) => {
    switch (action.type) {
        case "SET_SYSTEM_MESSAGES_ACTIVATED":
            return { ...state, isSystemMessagesActivated: action.payload };
        default:
            return state;
    }
};

export default marketingAutomationReducer;